import { useQuery } from '@tanstack/react-query';
import type { AuditLogEntry } from '@condo/contracts';
import { ApiRoutes } from '@condo/contracts';
import { api } from '@/lib/api/client';
import { queryKeys } from '@/lib/api/query-keys';

interface AuditLogResponse {
  items: AuditLogEntry[];
}

export function useAuditLog(condoId: string) {
  return useQuery({
    queryKey: queryKeys.auditLog(condoId),
    queryFn: () => api.get<AuditLogResponse>(ApiRoutes.auditLog(condoId)),
    enabled: !!condoId,
  });
}
